import { showSettingsLoader, showModalMessage } from 'actions';
import { caseDetails } from 'api/case-details';
import { CAPTURE_CONTACTS } from 'constants/ActionTypes';
import { dashboardQueryClient } from 'api/queryClients/dashboardQueryClient';
import { all, fork, takeEvery, put, select } from 'redux-saga/effects';

function* req_capture_contacts( { payload } ) {
	const caseIds = payload;
	const { auth } = yield select();
	yield put( showSettingsLoader( true ) );

	yield put(
		showModalMessage( {
			from    : '',
			show    : false,
			title   : '',
			message : ''
		} )
	);

	try {
		const response = yield caseDetails.forceContactCapture( { caseIds, userEmail: auth.userLogin } );

		yield put( showSettingsLoader( false ) );

		// O endpoint responde {results: [{caseId, success, message}]}, não mais
		// um {message} único no topo - por isso montamos a mensagem a partir do
		// resultado de cada caso em vez de ler response.data.message direto.
		const results = response?.data?.results || [];
		const failedResult = results.find( result => !result.success );
		const message = failedResult
			? failedResult.message || 'Não foi possível reiniciar a captura de contatos.'
			: 'Captura de contatos reiniciada com sucesso.';

		if ( !failedResult ) {
			caseIds.forEach( caseId =>
				dashboardQueryClient.invalidateQueries( [ 'contact-logs', caseId ] )
			);
		}

		yield put(
			showModalMessage( {
				from  : 'singleCase',
				show  : true,
				title : 'Atenção',
				message
			} )
		);
	} catch ( error ) {
		yield put( showSettingsLoader( false ) );
		yield put(
			showModalMessage( {
				from    : 'singleCase',
				show    : true,
				title   : 'Atenção',
				message : `[${error.status}] - ${error.statusText}`
			} )
		);
	}
}

export function* capture_contacts() {
	yield takeEvery( CAPTURE_CONTACTS, req_capture_contacts );
}

export default function* rootSaga() {
	yield all( [ fork( capture_contacts ) ] );
}
